import { generateEmailContent } from './generate-email-content';

// Container tag example: https://msasg.visualstudio.com/Bing_Ads/_git/AdsTracking_Core?path=/private/Container/TagContainerSnippet/Sample/tcs_prod.html
export function generateEventTag({
  action,
  currencyCode,
  goalValueType,
  i18n,
  tagType,
  uglify = false,
}) {
  const emailContent = generateEmailContent({
    i18n,
    action,
    currencyCode,
    goalValueType,
  });

  const eventAction = emailContent.EventAction;
  const eventProperties = emailContent.EventProperties;

  let tag = null;

  if (tagType === 'UET') {
    tag = `<script>
  function uet_report_conversion() {
    window.uetq = window.uetq || [];
    window.uetq.push("event", "${eventAction}", ${eventProperties});
  }
</script>`;
  } else if (tagType === 'UETPageLoad') {
    tag = `<script>
  window.uetq = window.uetq || [];
  window.uetq.push("event", "${eventAction}", ${eventProperties});
</script>`;
  } else if (tagType === 'UETExample') {
    tag = `<!DOCTYPE html>
<html lang="en">
<head>
{{highlighted}}// ${i18n.getString(_TL_('UET tag goes here.'))}{{/highlighted}}
{{highlighted}}// ${i18n.getString(_TL_('Copy and paste the event tag right after UET tag.'))}{{/highlighted}}
  <script>
    function {{highlighted}}uet_report_conversion(){{/highlighted}} {
      window.uetq = window.uetq || [];
      window.uetq.push("event", "${eventAction}", ${eventProperties});
    }
  </script>

</head>
<body>
{{highlighted}}// ${i18n.getString(_TL_('In the button code you want to track, call the function name from event tag.'))}{{/highlighted}}
  <button id="purchaseConfirmation" onclick="{{highlighted}}uet_report_conversion(){{/highlighted}}">${i18n.getString(_TL_('Sign Up Now'))}</button>
</body>
</html>`;
  } else if (tagType === 'UETPageLoadExample') {
    tag = `<!DOCTYPE html>
<html lang="en">
<head>
{{highlighted}}// ${i18n.getString(_TL_('UET tag goes here.'))}{{/highlighted}}
{{highlighted}}// ${i18n.getString(_TL_('Copy and paste the event tag right after UET tag.'))}{{/highlighted}}
  <script>
    window.uetq = window.uetq || [];
    window.uetq.push("event", "${eventAction}", ${eventProperties});
  </script>

</head>`;
  } else if (tagType === 'Container' || tagType === 'DMC') {
    tag = `<script>
  function report_conversion() {
    window.mtagq = window.mtagq || [];
    window.mtagq.push("event", "${eventAction}", ${eventProperties});
  }
</script>`;
  } else if (tagType === 'ContainerPageLoad' || tagType === 'DMCPageLoad') {
    tag = `<script>
  window.mtagq = window.mtagq || [];
  window.mtagq.push("event", "${eventAction}", ${eventProperties});
</script>`;
  } else if (tagType === 'ContainerExample' || tagType === 'DMCExample') {
    tag = `<!DOCTYPE html>
<html lang="en">
<head>
{{highlighted}}// ${i18n.getString(_TL_('Base tag goes here.'))}{{/highlighted}}
{{highlighted}}// ${i18n.getString(_TL_('Copy and paste the event tag right after base tag.'))}{{/highlighted}}
  <script>
    function {{highlighted}}report_conversion(){{/highlighted}} {
      window.mtagq = window.mtagq || [];
      window.mtagq.push("event", "${eventAction}", ${eventProperties});
    }
  </script>

</head>
<body>
{{highlighted}}// ${i18n.getString(_TL_('In the button code you want to track, call the function name from event tag.'))}{{/highlighted}}
  <button id="purchaseConfirmation" onclick="{{highlighted}}report_conversion(){{/highlighted}}">${i18n.getString(_TL_('Sign Up Now'))}</button>
</body>
</html>`;
  } else if (tagType === 'ContainerPageLoadExample' || tagType === 'DMCPageLoadExample') {
    tag = `<!DOCTYPE html>
<html lang="en">
<head>
{{highlighted}}// ${i18n.getString(_TL_('Base tag goes here.'))}{{/highlighted}}
{{highlighted}}// ${i18n.getString(_TL_('Copy and paste the event tag right after base tag.'))}{{/highlighted}}
  <script>
    window.mtagq = window.mtagq || [];
    window.mtagq.push("event", "${eventAction}", ${eventProperties});
  </script>

</head>`;
  } else {
    return null;
  }

  if (uglify) {
    // NOTE: not a true uglify, just removes newlines and leading spaces
    return tag.replace(/(^\s+|\n)/gm, '');
  }

  return tag;
}
